module.exports = __webpack_public_path__ + "img/pumpkin.420442b0.png";